import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project-money",
  "use": "icon-project-money-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-project-money\">\r\n<path d=\"M100,0C44.9,0,0,44.9,0,100s44.9,100,100,100s100-44.9,100-100S155.1,0,100,0z M144.3,114.8c9.5,0,9.5,13.3,0,13.3H106V159\r\n\tc0,9.5-13.3,9.5-13.3,0v-30.8h-37c-9.5,0-9.5-13.3,0-13.3h37v-14.1h-37c-9.5,0-9.5-13.3,0-13.3h29.9L52.9,45\r\n\tc-5.8-7.5,4.7-15.7,10.5-8.1l36,46.6l36-46.6c5.8-7.5,16.3,0.6,10.5,8.1l-32.7,42.4h31.2c9.5,0,9.5,13.3,0,13.3H106v14.1\r\n\tL144.3,114.8L144.3,114.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/home/project-money.svg
// module id = 88OY
// module chunks = 13